import { ArrowUpRight, GitBranch } from "lucide-react";
import React from "react";
import { DateTime } from "./DateTime";

const formatProjectName = (reference) => {
	const parts = reference.split("/");
	if (parts.length <= 1) return reference;
	parts.splice(0, 1);

	const projectPart = parts.join("/");
	return projectPart;
};

export const RecentPushes = ({ pushes }) => {
	if (pushes.length === 0) return null;

	return (
		<div className="space-y-2 mb-6">
			{pushes.map((push) => (
				<div
					key={push.id}
					className="group flex items-center gap-3 rounded-xl bg-[var(--surface-elevated)] px-3 py-2.5 shadow-sm ring-1 ring-[var(--surface-elevated-ring)] transition-shadow hover:shadow-md"
				>
					<div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[var(--color-accent)]/10 text-[var(--color-accent)] ring-1 ring-[var(--color-accent)]/15">
						<GitBranch className="h-4 w-4" />
					</div>
					<div className="min-w-0 flex-1">
						<div className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide text-[var(--surface-elevated-muted)]">
							<span>Recent push</span>
							<span aria-hidden="true">·</span>
							<DateTime date={push.created_at} />
						</div>
						<div className="mt-0.5 truncate text-sm text-[var(--color-text-primary)]">
							<a
								href={`${push.projectInfo.webUrl}/-/tree/${push.push_data.ref}`}
								className="font-mono font-medium text-[var(--color-accent)] hover:underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								{push.push_data.ref}
							</a>{" "}
							<span className="text-[var(--surface-elevated-muted)]">in</span>{" "}
							<a
								href={push.projectInfo.webUrl}
								className="font-medium hover:underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								{formatProjectName(push.projectInfo.fullPath)}
							</a>
						</div>
					</div>
					<a
						href={`${push.projectInfo.webUrl}/-/merge_requests/new?merge_request%5Bsource_branch%5D=${encodeURIComponent(push.push_data.ref)}`}
						className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-[var(--color-accent)] px-3 py-1.5 text-sm font-medium text-[var(--color-accent-contrast)] shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-opacity-50 active:scale-[0.97] transition-[opacity,transform]"
						target="_blank"
						rel="noopener noreferrer"
					>
						Create MR
						<ArrowUpRight className="h-4 w-4 transition-transform duration-300 ease-out motion-safe:group-hover:translate-x-0.5 motion-safe:group-hover:-translate-y-0.5" />
					</a>
				</div>
			))}
		</div>
	);
};
